import { render } from "./ClinicFormData.vue?vue&type=template&id=21712e70&scoped=true"
import script from "./ClinicFormData.vue?vue&type=script&lang=js"
export * from "./ClinicFormData.vue?vue&type=script&lang=js"

import "./ClinicFormData.vue?vue&type=style&index=0&id=21712e70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21712e70"]])

export default __exports__